import { setChatListFailed, setChatListPending, setFullChatListSucceed } from './actions';
import { IChatListRequest } from './types';
import { fetchChats, IChatsRequest, TChatsResponse } from '../../repositories/chats/v1/chats';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { CHATS_ON_PAGE_LIMIT } from '../../types/chatList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { setRoute } from '../route';

/**
 * Получить список непрочитанных чатов
 * FIXME: Пока ручки для получения всех непрочитанных нет, берем из обычных чатов
 */
export const getUnreadChats =
  ({ notClearCurrentOpenedChatId, timestamp }: IChatListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const state = getState();

    const {
      chatList,
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setChatListPending({ notClearCurrentOpenedChatId, timestamp }));

    const parameters: IChatsRequest = {
      limit: CHATS_ON_PAGE_LIMIT,
      timestampMs: timestamp,
      subAgentRealtyUserId,
    };

    try {
      const chatsResponse: TChatsResponse = await fetchChats({
        httpApi,
        parameters,
        config: { requestConfig: { withCredentials: true } },
      });

      if (chatsResponse.statusCode === 200) {
        dispatch(setFullChatListSucceed(chatsResponse.response.chats.filter(({ unread }) => !!unread)));

        /**
         * Ставим активный пункт меню - сообщения
         */
        if (chatList.currentRoute !== ERoute.Unread) {
          dispatch(setRoute({ route: ERoute.Unread }));
        }
      } else {
        dispatch(setChatListFailed());
      }
    } catch (error) {
      logger.error(error, {
        message: 'Не удалось получить список непрочитанных чатов',
        domain: 'src/shared/actions/chatList/getUnreadChats.ts',
      });

      dispatch(setChatListFailed());
    }
  };
